// removed by extract-text-webpack-plugin
module.exports = {"container":"container___wT_W2","add":"add___ZHTzI","delete":"delete___2h6_0","modifierContainer":"modifierContainer___2laeu","extraMargin":"extraMargin___1kP3X","modifierBlock":"modifierBlock___2xOST","replaceWrapper":"replaceWrapper___1ZU7H","replaceBlock":"replaceBlock___h11p_","option":"option___1pSeL","backer":"backer___35-M7","select":"select___20yUU","handle":"handle___1c1wK","bars":"bars___2zilZ","switchBtn":"switchBtn___1NIer"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/EditVariable/ModifiersEditor/styles.scss
// module id = 406
// module chunks = 0